"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Room = void 0;
class Room {
    constructor(room) {
        var _a;
        this.description = room.description;
        this.is_styret = room.is_styret;
        this.sakformat = room.sakformat;
        this.saknummer = room.saknummer;
        this.title = room.title;
        this.deleted = room.deleted;
        this.hidden = (_a = room.hidden) !== null && _a !== void 0 ? _a : false;
        this.has_room = room.has_room;
        this.tasks = room.tasks !== false;
        this.meetings = room.meetings !== false;
        this.files = room.files !== false;
    }
    static new(data) {
        const roomData = {
            description: '',
            is_styret: false,
            sakformat: '',
            saknummer: 0,
            title: '',
            deleted: false,
            hidden: false,
            has_room: false,
            tasks: true,
            files: true,
            meetings: true,
        };
        if (data) {
            Object.keys(data).forEach((key) => {
                // already have checks that key is in both
                roomData[key] = data[key];
            });
        }
        return new this(roomData);
    }
    static fromQueryDocumentSnapshot(snapshot) {
        if (!snapshot.exists) {
            return undefined;
        }
        const room = this.new(snapshot.data());
        room._querySnap = snapshot;
        room._ref = snapshot.ref;
        room._parentId = snapshot.ref.parent.parent.id;
        return room;
    }
    static fromQuerySnapshot(snapshot) {
        const rooms = [];
        if (snapshot.empty) {
            return rooms;
        }
        // eslint-disable-next-line no-restricted-syntax
        for (const d of snapshot.docs) {
            const room = this.fromQueryDocumentSnapshot(d);
            if (room) {
                rooms.push(room);
            }
        }
        return rooms;
    }
    getRaw() {
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    querySnap() {
        if (!this._querySnap) {
            throw new Error('Somehow querysnap does not exist! room');
        }
        return this._querySnap;
    }
    ref() {
        if (!this._ref) {
            throw new Error('Somehow ref does not exist! room');
        }
        return this._ref;
    }
    getId() {
        const qs = this.querySnap();
        if (!qs) {
            throw new Error('Somehow id does not exist! room');
        }
        return qs.id;
    }
    parentID() {
        if (!this._parentId) {
            throw new Error('Somehow parentid does not exist! room');
        }
        return this._parentId;
    }
}
exports.Room = Room;
//# sourceMappingURL=room.js.map